var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 18C18.1046 18 19 17.1046 19 16H20C21.1046 16 22 15.1046 22 14V4C22 2.89543 21.1046 2 20 2H19C19 0.89543 18.1046 0 17 0H5C3.89543 0 3 0.89543 3 2H2C0.89543 2 0 2.89543 0 4V14C0 15.1046 0.89543 16 2 16H3C3 17.1046 3.89543 18 5 18H17ZM17 2V16H5V2H17ZM11 9.14046V4.13148L15.5547 7.16795L14.4453 8.83205L13 7.86852V11.5C13 12.9534 11.6046 14 10 14C8.39543 14 7 12.9534 7 11.5C7 10.0466 8.39543 9 10 9C10.3471 9 10.6845 9.04898 11 9.14046ZM2 4H3V14H2V4ZM19 14H20V4H19V14ZM11 11.5C11 11.7034 10.6046 12 10 12C9.39543 12 9 11.7034 9 11.5C9 11.2966 9.39543 11 10 11C10.6046 11 11 11.2966 11 11.5Z",
    fill: "#898F97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.f59f80edda316969d638d1ddc9536247.svg";
export { ForwardRef as ReactComponent };